<template>
  <div>
    <div
      id="header"
      v-if="SETUP_UI.isSmall"
      :style="{
        backgroundColor: backgroundColor,
        paddingTop: '170px'
      }"
    >
      <v-container fill-height>
        <v-row align="center">
          <v-col cols="12" sm="12" md="7" lg="7" xl="7" data-aos="fade-right">
            <v-container>
              <p
                :class="
                  `${MIXIN_SETUP_UI.header} font-weight-black pt-3 ${titleColor}--text `
                "
              >
                {{ title }}
              </p>

              <p :class="`sub pb-5 ${captionColor}--text pre-wrap`">
                {{ caption }}
              </p>

              <!-- Buttons -->
              <span class="ma-0 pa-0" v-for="(btn, key) in buttons" :key="key">
                <router-link v-if="btn.link.charAt(0) == '/'" :to="btn.link">
                  <base-button
                    :name="btn.name"
                    :color="btn.color"
                    :icon="btn.icon"
                    :x-large="!MIXIN_SETUP_UI.isSmallButton"
                    :medium="MIXIN_SETUP_UI.isSmallButton"
                    depressed
                    class="mr-3 mt-3"
                  ></base-button>
                </router-link>
                <a v-else :href="btn.link">
                  <base-button
                    :name="btn.name"
                    :color="btn.color"
                    :icon="btn.icon"
                    :x-large="!MIXIN_SETUP_UI.isSmallButton"
                    :medium="MIXIN_SETUP_UI.isSmallButton"
                    depressed
                    class="mr-3 mt-3"
                  ></base-button>
                </a>
              </span>

              <slot name="extra-field"></slot>
            </v-container>
          </v-col>

          <slot name="right-image"></slot>
        </v-row>
        <v-row>
          <v-img :src="backgroundImage"></v-img>
        </v-row>
      </v-container>
    </div>
    <div
      v-else
      id="header"
      :style="{
        backgroundColor: backgroundColor,
        background: `url(${backgroundImage}) 80% 10% / cover no-repeat`
      }"
    >
      <v-container fill-height>
        <v-row align="center">
          <v-col cols="12" sm="12" md="7" lg="7" xl="7" data-aos="fade-right">
            <v-container>
              <p
                :class="`display-3 font-weight-black py-3 ${titleColor}--text`"
              >
                {{ title }}
              </p>

              <p :class="`sub pt-2 pb-5 ${captionColor}--text pre-wrap`">
                {{ caption }}
              </p>

              <!-- Buttons -->
              <span class="ma-0 pa-0" v-for="(btn, key) in buttons" :key="key">
                <router-link v-if="btn.link.charAt(0) == '/'" :to="btn.link">
                  <base-button
                    :name="btn.name"
                    :color="btn.color"
                    :icon="btn.icon"
                    x-large
                    depressed
                    class="mr-3 mt-3"
                  ></base-button>
                </router-link>
                <a v-else :href="btn.link">
                  <base-button
                    :name="btn.name"
                    :color="btn.color"
                    :icon="btn.icon"
                    x-large
                    depressed
                    class="mr-3 mt-3"
                  ></base-button>
                </a>
              </span>

              <slot name="extra-field"></slot>
            </v-container>
          </v-col>

          <slot name="right-image"></slot>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseBanner",
  props: {
    title: { type: String, default: "" },
    caption: { type: String, default: "" },
    backgroundColor: { type: String, default: "" },
    backgroundImage: { type: String, default: "" },
    titleColor: { type: String, default: "" },
    captionColor: { type: String, default: "" },
    buttons: { type: Array }
  },
  data: () => ({
    //
  }),
  computed: {
    SETUP_UI() {
      /**
       * ALL OBJECT KEY RETURN BY THIS FUNCTION MUST HAVE A COUNTERPART ON OTHER VIEWS
       */
      let breakpoint = this.$vuetify.breakpoint.name;

      if (["xs", "sm"].includes(breakpoint)) {
        return {
          isSmall: true
        };
      }

      /**
       * "md", "lg", "xl"
       */
      return {
        isSmall: false
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

#header {
  height: 750px;

  .v-btn {
    justify-content: left !important;
  }
}
</style>
